import { Button } from "@/components/ui/button"
import { Star } from "lucide-react"

const CampaignSupport = () => {
  return (
    <section className="relative py-24 overflow-hidden">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-red-500 via-orange-500 via-yellow-500 via-green-500 via-blue-500 via-indigo-500 to-violet-500 opacity-20"></div>
        <div className="absolute inset-0 bg-[linear-gradient(45deg,_#FF0000_0%,_#FF7F00_16.666%,_#FFFF00_33.333%,_#00FF00_50%,_#0000FF_66.666%,_#4B0082_83.333%,_#8F00FF_100%)] opacity-15"></div>
      </div>
      <div className="absolute inset-0 backdrop-blur-[80px]" />
      
      <div className="relative container">
        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 rounded-full px-4 py-1 text-sm leading-6 bg-white/10 text-white backdrop-blur-md ring-1 ring-white/20 hover:ring-white/30 mb-6 shadow-lg">
            <Star className="w-4 h-4" />
            <span>Join the Movement</span>
          </div>
          
          <h2 className="text-4xl sm:text-5xl font-bold tracking-tight text-white mb-6 drop-shadow-lg">
            Support Fashion For All
          </h2>
          
          <p className="text-lg sm:text-xl text-white/90 mb-8 leading-relaxed">
            Join us in supporting the "Cute Fashion For All" campaign on Change.org. Together, we can make fashion more inclusive and accessible for everyone.
          </p>
          
          <Button
            size="lg"
            className="bg-white hover:bg-white/90 text-fembot-pink hover:text-fembot-pink/90 shadow-lg group backdrop-blur-sm font-semibold px-8"
            onClick={() => window.open('https://www.change.org/cutefashionforall', '_blank')}
          >
            <span className="flex items-center gap-2">
              Support the Campaign
              <span className="group-hover:translate-x-1 transition-transform">→</span>
            </span>
          </Button>
        </div>
      </div>
    </section>
  )
}

export default CampaignSupport
